import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import apiHelper from 'helpers/api-helper';
import appConfig from 'config/app.config';
import {getText} from 'helpers/language-helper';
import {getPlayerModuleSessionData} from 'helpers/module-helper';
import {adminUiTexts} from 'data/ui-texts/admin-ui-texts';
import Button from 'components/ui/button/button';
import './admin-refactor-player-data-popup.scss';

const AdminRefactorPlayerDataPopup = ({languageId, togglePopup}) => {
	/* Loading status and feedback */
	const [isLoading, setIsLoading] = useState(false);
	const [feedback, setFeedback] = useState(null);

	const [players, setPlayers] = useState([]);


	/**
	 * Refactor player data
	 */
	const refactorPlayerData = () => {
		if (isLoading) return;

		setIsLoading(true);
		apiHelper('admin/refactor-player-data').then(
			(response) => {
				if (response && response.errors && response.errors.length > 0) {
					console.log(response.errors);
					setFeedback('errors');
				}
				setIsLoading(false);
			},
			(rejection) => {
				/* Error: server error */
				console.error(rejection);
				setFeedback('error');
				setIsLoading(false);
			}
		);
	};


	/**
	 * Component did mount / will unmount
	 */
	useEffect(() => {
		const db = firebase.firestore();
		db.collection(appConfig.playersDbName).get().then((docs) => {
			let newPlayers = [];
			docs.forEach((doc) => {
				if (doc.exists && doc.data()) {
					newPlayers.push({...doc.data(), id: doc.id});
				}
			});
			setPlayers(newPlayers);
		}).catch((error) => {
			/* Error: could not connect to database */
			console.error(error);
			this.setState({isLoading: false});
		});
	}, []);

	
	return (
		<div className="AdminRefactorPlayerDataPopup" onClick={() => {togglePopup(null);}}>
			<div className="AdminRefactorPlayerDataPopup-content" onClick={(e) => {e.stopPropagation();}}>
				{/* Popup header */}
				<div className="AdminRefactorPlayerDataPopup-header">
					<div className="AdminRefactorPlayerDataPopup-title">
						<span>{getText(adminUiTexts.refactorPlayerDataPopup.title, languageId)}</span>
					</div>
					<div className="AdminRefactorPlayerDataPopup-closeBtn" onClick={() => {togglePopup();}}/>
				</div>

				{/* Popup body */}
				<div className="AdminRefactorPlayerDataPopup-body">

					<div className="AdminRefactorPlayerDataPopup-players">
						<div className="AdminRefactorPlayerDataPopup-playerRow header">
							<div className="AdminRefactorPlayerDataPopup-playerCell id">
								<span>Id</span>
							</div>
							<div className="AdminRefactorPlayerDataPopup-playerCell">
								<span>Game status</span>
							</div>
							<div className="AdminRefactorPlayerDataPopup-playerCell">
								<span>Module 1 status</span>
							</div>
							<div className="AdminRefactorPlayerDataPopup-playerCell">
								<span>Module 2 status</span>
							</div>
						</div>
						{players.map((player) => {
							const playerModule1SessionData = getPlayerModuleSessionData(player, 's1-m1');
							const playerModule2SessionData = getPlayerModuleSessionData(player, 's1-m2');

							let module1Status = 'ikke begyndt';
							if (playerModule1SessionData) {
								module1Status = 'begyndt';
								if (playerModule1SessionData.isCompleted) {
									module1Status = 'completed';
								}
							}
							let module2Status = 'ikke begyndt';
							if (playerModule2SessionData) {
								module2Status = 'begyndt';
								if (playerModule2SessionData.isCompleted) {
									module2Status = 'completed';
								}
							}
							return (
								<div key={player.id} className="AdminRefactorPlayerDataPopup-playerRow body">
									<div className="AdminRefactorPlayerDataPopup-playerCell id">
										<span>{player.userId} ({player.id})</span>
									</div>
									<div className="AdminRefactorPlayerDataPopup-playerCell">
										<span>{player.completed ? 'completed' : 'not completed'}</span>
									</div>
									
									<div className="AdminRefactorPlayerDataPopup-playerCell">
										<span>{module1Status}</span>
									</div>
									<div className="AdminRefactorPlayerDataPopup-playerCell">
										<span>{module2Status}</span>
									</div>
								</div>
							);
						})}
					</div>
					
					<div className="AdminRefactorPlayerDataPopup-uploadBtn">
						<Button 
							isLoading={isLoading}
							text={getText(adminUiTexts.refactorPlayerDataPopup.refactor, languageId)}
							classes={['admin']} 
							onClick={() => {refactorPlayerData();}}
						/>
					</div>

					<div className="AdminRefactorPlayerDataPopup-feedback"><span>{feedback}</span></div>
				</div>
			</div>
		</div>
	);
};

AdminRefactorPlayerDataPopup.propTypes = {
	languageId: PropTypes.string.isRequired,
	togglePopup: PropTypes.func.isRequired,
};

export default AdminRefactorPlayerDataPopup;
